var exports = {
  "k": "x61f99309--407563--container",
  "p": "x61f99309--407563--info",
};

module.exports = exports;
